import { alpha, Box, Paper, Typography } from "@mui/material";

export const MiniChip = ({ color, icon, label }) => (
  <Box
    title={typeof label === 'string' ? label : undefined}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      height: 20,
      px: 0.75,
      borderRadius: 1,
      bgcolor: alpha(color, 0.1),
      color,
      fontSize: 11,
      fontWeight: 700,
      maxWidth: '100%',
      minWidth: 0,
      '& svg': { fontSize: 13, flexShrink: 0 },
    }}
  >
    {icon}
    <Box
      component="span"
      sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
    >
      {label}
    </Box>
  </Box>
);



export const StatBox = ({ label, value, color = '#159073', subvalue }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 1.5,
      borderRadius: 1.5,
      bgcolor: alpha(color, 0.04),
      borderColor: alpha(color, 0.2),
      height: '100%',
    }}
  >
    <Typography variant="caption" color="text.secondary" display="block" noWrap>
      {label}
    </Typography>
    <Typography variant="h6" fontWeight={700} sx={{ color, lineHeight: 1.2, mt: 0.5 }} noWrap>
      {value || '--'}
    </Typography>
    {subvalue && (
      <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ mt: 0.25 }}>
        {subvalue}
      </Typography>
    )}
  </Paper>
);